import type * as React from "react";

import { useTranslate } from "@similarweb/i18n-provider";

import { DataTitle } from "app/components/single-metric/cell-templates/styledComponents";
import { IntentDistributionChart } from "app/pages/keyword-research/common-components/intent-distribution-chart/IntentDistributionChart";
import type { IIntentDistributionChartData } from "app/pages/keyword-research/common-components/intent-distribution-chart/intentDistributionChartTypes";
import { DataRowTitle } from "app/pages/keyword-research/keyword-analysis/pages/keywords-overview/components/datarow/DataRowStyledComponents";
import { SUMMARY_CARD_HEIGHT } from "app/pages/keyword-research/website-analysis/pages/seo-overview/summary/consts";
import type { IIntentDistributionData } from "app/pages/keyword-research/website-analysis/pages/seo-overview/types";
import BoxTitle from "pro-features/components/BoxTitle/src/BoxTitle";

import { MetricContainer } from "../../StyledComponent";

const CONTAINER_PADDING = 24;
const CONTAINER_HEIGHT = `${SUMMARY_CARD_HEIGHT - CONTAINER_PADDING * 2}px`;

const transformIntentDistributionData = (data: IIntentDistributionData) =>
    Object.keys(data).reduce((acc, key: keyof IIntentDistributionData) => {
        acc[key.toLowerCase()] = data[key];
        return acc;
    }, {} as IIntentDistributionChartData);

interface IShareBarGraphProps {
    data?: IIntentDistributionData;
    title?: string;
    toolTip?: string;
    isLoading?: boolean;
}

export const IntentDistribution: React.FC<IShareBarGraphProps> = ({
    data,
    title = "website.seo.overview.intentdistribution.title",
    toolTip = "website.seo.overview.intentdistribution.toolTip",
    isLoading,
}) => {
    const { translate } = useTranslate();
    const finalData = data && transformIntentDistributionData(data);
    return (
        <MetricContainer
            minWidth="264px"
            height={CONTAINER_HEIGHT}
            padding={`${CONTAINER_PADDING}px`}
        >
            <BoxTitle
                Container={DataRowTitle}
                tooltip={translate(toolTip)}
            >
                <DataTitle>{translate(title)}</DataTitle>
            </BoxTitle>
            <IntentDistributionChart
                data={finalData}
                isLoading={isLoading}
            />
        </MetricContainer>
    );
};
